import React from 'react';
import { Configuration } from '../data/configuration.js';
import { InteriorConfigurator } from '../configurator/interior-configurator.ts';


//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface GearboxViewProps {
	onBackButtonClicked: () => void;
	onGearboxSelected: () => void;
	interiorConfigurator: InteriorConfigurator;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export function GearboxView(props: GearboxViewProps) {
	
	// handlers.

	const handleGearboxItemClicked = (event: React.MouseEvent<HTMLElement>) => {

		// get the item ID.
		const id = event.currentTarget.dataset.id;
		if (id) {

			// update the configuration.
			Configuration.transmission = id;
			Configuration.updateCosts();

			// update gear stick on the model.
			props.interiorConfigurator.selectGearStick();

			// call the callback fn.
			props.onGearboxSelected();
		}

		// or log an error.
		else {
			console.error('Mising data-id on element: ', event.currentTarget);
		}
	};
	
	// return the HTML.
	return (
		<div id="gearbox-view">
			<div id="gearbox-content">
				<a role="button" className="gearbox-item" data-id="MS008" onClick={handleGearboxItemClicked}>
					<img className="gear-image" src="assets/images/configuration-items/gearbox/manual-gearbox.webp" width="240" height="141" alt="Manual Gearbox" />
					<div className="gearbox-text">
						<p>MANUAL</p>
						<img src="assets/images/icons/down-arrow.svg" width="18" height="10" alt=">" />
					</div>
				</a>
				<a role="button" className="gearbox-item" data-id="MS005" onClick={handleGearboxItemClicked}>
					<img className="gear-image" src="assets/images/configuration-items/gearbox/auto-gearbox.webp" width="240" height="141" alt="Automatic Gearbox" />
					<div className="gearbox-text">
						<p>AUTOMATIC</p>
						<img src="assets/images/icons/down-arrow.svg" width="18" height="10" alt=">" />
					</div>
				</a>
			</div>
			<div id="gearbox-footer">
				<button type="button" onClick={props.onBackButtonClicked}>BACK</button>
			</div>
		</div>
	);
}
